import { BaseQuery, QueryConfig, QueryResponse, QueryResult } from "@/shared/types/base";
import { CajaApertura } from "@/shared/types/caja-apertura";
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface CajaAperturasQuery extends BaseQuery {
    cajaId?: string,
    aperturaDesde?: string,
    aperturaHasta?: string,
    cierreDesde?: string,
    cierreHasta?: string
}

export async function getAllCajaAperturas(query?: CajaAperturasQuery): Promise<QueryResponse<CajaApertura>> {
    await sleep(1000);
    const response = await api.get("cajas/aperturas", { params: removeNullOrEmptyKeys(query) });
    return response.data;
}

export function useGetAllCajaAperturasQuery(query: CajaAperturasQuery = {}, queryConfig: QueryConfig<QueryResponse<CajaApertura>> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getAllCajaAperturas(query),
        queryKey: ["cajas", "aperturas", query],
    })
}

export interface GetAllCajaAperturaQueryProps {
    query?: CajaAperturasQuery,
    queryConfig?: QueryConfig<QueryResponse<CajaApertura>>,
    children: (queryResult: QueryResult<QueryResponse<CajaApertura>>) => ReactNode
}

export function GetAllCajaAperturasQuery({
    query,
    queryConfig,
    children
}: GetAllCajaAperturaQueryProps) {
    const queryResult = useGetAllCajaAperturasQuery(query, queryConfig);
    return children && children(queryResult);
}